import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { blogAPI, authAPI } from '../../services/api';
import { useToast } from '../../context/ToastContext';
import { LoadingPage } from '../../components/Loading';
import './Member.css';

const Dashboard = () => {
  const { error: toastError } = useToast();
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const [recentPosts, setRecentPosts] = useState([]);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const [profileRes, postsRes] = await Promise.all([
        authAPI.getProfile(),
        blogAPI.getLatest(),
      ]);

      setProfile(profileRes.data);
      const posts = Array.isArray(postsRes.data) ? postsRes.data : postsRes.data?.results || [];
      setRecentPosts(posts.slice(0, 5));
    } catch (error) {
      console.error('Failed to fetch dashboard data:', error);
      toastError('載入儀表板資料失敗');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  if (loading) {
    return <LoadingPage message="加載中..." />;
  }

  const memberProfile = profile?.profile;

  return (
    <div className="member-page">
      <h1 className="dashboard-title">會員儀表板</h1>

      <div className="dashboard-top-grid">
        <div className="member-card quick-access-top">
          <h2>快速操作</h2>
          <div className="quick-actions">
            <Link to="/member/qr-code" className="action-button">
              <span className="action-icon">🔖</span>
              <span>我的QR碼</span>
            </Link>
            <Link to="/member/profile" className="action-button">
              <span className="action-icon">👤</span>
              <span>個人資料</span>
            </Link>
            <Link to="/blog" className="action-button">
              <span className="action-icon">📝</span>
              <span>最新消息</span>
            </Link>
            <Link to="/member/change-password" className="action-button">
              <span className="action-icon">🔒</span>
              <span>修改密碼</span>
            </Link>
          </div>
        </div>

        <div className="welcome-section member-card">
          <h2>歡迎回來，{memberProfile?.chinese_name || profile?.phone_number}！</h2>
          <div className="member-info-row">
            <div className="info-item">
              <span className="info-label">會員編號</span>
              <span className="info-value">{memberProfile?.member_number || 'N/A'}</span>
            </div>
            <div className="info-item">
              <span className="info-label">加入日期</span>
              <span className="info-value">
                {memberProfile?.membership_date
                  ? new Date(memberProfile.membership_date).toLocaleDateString('zh-HK', { year: 'numeric', month: 'long', day: 'numeric' })
                  : memberProfile?.created_at
                    ? new Date(memberProfile.created_at).toLocaleDateString('zh-HK', { year: 'numeric', month: 'long', day: 'numeric' })
                    : 'N/A'}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="member-card">
        <div className="section-header">
          <h2>最新消息</h2>
          <Link to="/blog" className="view-all-link">查看全部 →</Link>
        </div>

        {recentPosts.length > 0 ? (
          <div className="registrations-list">
            {recentPosts.map((post) => (
              <div key={post.id} className="registration-item">
                <div className="registration-info">
                  <h3>{post.title}</h3>
                  {post.published_date && (
                    <p className="event-date">
                      📅 {new Date(post.published_date).toLocaleDateString('zh-HK', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}
                    </p>
                  )}
                  {post.summary && <p>{post.summary}</p>}
                </div>
                <Link to={`/blog/${post.id}`} className="btn btn-outline">
                  閱讀
                </Link>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-data">暫無最新消息</p>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
